import { type AdvancingActivitySource } from "advancing/activity/AdvancingActivityLog";
import moment from "moment";
import { parseLocalizedNumber } from "shared/utils/numberInputUtils";

// The server and the inputs can write the same value differently, e.g. "10,50" and "10,5"
export const isSameAdvancingValue = (type: server.dto.FormElementTypes, a: string, b: string): boolean => {
  if (!a || !b) return !a && !b;

  switch (type) {
    case "time":
      return moment.utc(a).format("HH:mm") === moment.utc(b).format("HH:mm");
    case "date":
      return moment.utc(a).format("YYYY-MM-DD") === moment.utc(b).format("YYYY-MM-DD");
    case "dateTime":
      return moment.utc(a).valueOf() === moment.utc(b).valueOf();
    case "decimal":
      return parseLocalizedNumber(a, serverReference.culture.uiLocale) === parseLocalizedNumber(b, serverReference.culture.uiLocale);
    case "integer":
    case "integerNullable":
    case "capacity":
    case "percentage":
    case "money":
      return parseFloat(a) === parseFloat(b);
    default:
      return a === b;
  }
};

export const getProvideActivitySource = (secret: string): AdvancingActivitySource => ({
  queryKey: ["AdvancingSession.ListActivity", secret],
  fetchPage: (page, perPage) => window.CoreApi.AdvancingSession.ListActivity({ secret, page, perPage })
});

export const getProvideSidePanelQuery = (secret: string) => ({
  queryKey: ["AdvancingProvide.GetSidePanelData", secret],
  queryFn: () => window.CoreApi.AdvancingProvide.GetSidePanelData(secret).then(r => r.data)
});
